import { defineMessages } from 'react-intl';

export const messages: Record<
	string,
	{ id: string; defaultMessage: string; description?: string }
> = defineMessages({
	title: {
		id: 'conversation-assistant-message-actions.controllers.jira-move-to-sprint.title',
		defaultMessage: 'Move to sprint',
		description: 'Heading shown at the top of the move to sprint action card in Rovo chat.',
	},
	sprintLabel: {
		id: 'conversation-assistant-message-actions.controllers.jira-move-to-sprint.sprintLabel',
		defaultMessage: 'Sprint ID',
		description: 'Label for the sprint detail row in the move to sprint action card.',
	},
	issuesLabel: {
		id: 'conversation-assistant-message-actions.controllers.jira-move-to-sprint.issuesLabel',
		defaultMessage: '{count, plural, one {Issue} other {Issues}}',
		description:
			'Label for the issues detail row in the move to sprint action card. Singular when one issue, plural otherwise.',
	},
	confirmButton: {
		id: 'conversation-assistant-message-actions.controllers.jira-move-to-sprint.confirmButton',
		defaultMessage: 'Confirm',
		description:
			'Label for the confirm button in the move to sprint action card that submits the action.',
	},
	cancelButton: {
		id: 'conversation-assistant-message-actions.controllers.jira-move-to-sprint.cancelButton',
		defaultMessage: 'Cancel',
		description:
			'Label for the cancel button in the move to sprint action card that dismisses the action.',
	},
});
